import React from 'react';

interface LayoutToggleProps {
  mode: 'single' | 'double';
  onChange: (mode: 'single' | 'double') => void;
}

export const LayoutToggle: React.FC<LayoutToggleProps> = ({ mode, onChange }) => {
  const isDouble = mode === 'double';

  return (
    <button
      type="button"
      onClick={() => onChange(isDouble ? 'single' : 'double')}
      aria-label={isDouble ? 'Passer en vue colonne unique' : 'Passer en vue deux colonnes'}
      className="relative flex items-center w-14 h-7 bg-gray-200 rounded-full p-0.5 transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-1"
    >
      <span
        className={`
          absolute w-6 h-6 bg-white rounded-full shadow-md
          flex items-center justify-center
          transition-transform duration-300 ease-in-out
          ${isDouble ? 'translate-x-7' : 'translate-x-0'}
        `}
      >
        {isDouble ? (
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.5" y="0.5" width="5" height="13" rx="1" stroke="#6b7280" strokeWidth="1.2" fill="none" />
            <rect x="8.5" y="0.5" width="5" height="13" rx="1" stroke="#6b7280" strokeWidth="1.2" fill="none" />
          </svg>
        ) : (
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="1.5" y="0.5" width="11" height="13" rx="1" stroke="#6b7280" strokeWidth="1.2" fill="none" />
            <line x1="1.5" y1="4.5" x2="12.5" y2="4.5" stroke="#6b7280" strokeWidth="1.2" />
            <line x1="1.5" y1="8" x2="12.5" y2="8" stroke="#6b7280" strokeWidth="1.2" />
          </svg>
        )}
      </span>
    </button>
  );
};
